import * as React from "react"
import { Logo } from "@/components/ui/logo"

/**
 * The frame every unauthenticated screen sits in: lockup, card, and an
 * optional note under the card. The note lives outside the card on purpose —
 * it is orientation ("invite-only", "this link expires"), not part of the
 * form, and the design keeps that distinction.
 */
export function AuthShell({
  children,
  footer,
}: {
  children: React.ReactNode
  footer?: React.ReactNode
}) {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-6 bg-surface px-4 py-12 text-ink-body">
      <Logo layout="stacked" />
      <div className="w-full max-w-sm rounded-xl border border-hairline bg-page p-6 shadow-sm">
        {children}
      </div>
      {footer && (
        <p className="max-w-xs text-center text-xs text-ink-muted">{footer}</p>
      )}
    </div>
  )
}
